/**
 * Конфигурация сборки.
 *
 * Секретов здесь быть не может: бандл отдаётся клиенту целиком.
 * Всё, что требует секрета, делается на бэкенде.
 */

const rawApiBase = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';

/**
 * Имя бота — одно на всё приложение: из него собираются реферальные
 * ссылки и заглушка поддержки. Задаётся VITE_BOT_USERNAME; значение
 * по умолчанию — тестовый бот.
 */
const botUsername = (import.meta.env.VITE_BOT_USERNAME ?? '').trim().replace(/^@/, '') || 'vpntest96bot';

/**
 * Заглушка поддержки: ведёт в самого бота, пока нет отдельного чата.
 * Настоящий адрес задаётся VITE_SUPPORT_URL и заменяет эту ссылку.
 */
const SUPPORT_FALLBACK = `https://t.me/${botUsername}`;

/** Пустая строка в переменной окружения — то же, что её отсутствие. */
function optional(value: string | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

export const config = {
  apiBaseUrl: rawApiBase.replace(/\/+$/, ''),
  isDev: import.meta.env.DEV,
  botUsername,
  // Адреса задаются при сборке, а не зашиваются в код: чат поддержки
  // и документы меняются независимо от релизов приложения.
  supportUrl: optional(import.meta.env.VITE_SUPPORT_URL) ?? SUPPORT_FALLBACK,
  // По умолчанию — страницы на домене приложения (public/legal): их же
  // указываем платёжному провайдеру, и они открываются без Telegram.
  offerUrl: optional(import.meta.env.VITE_OFFER_URL) ?? '/legal/offer.html',
  privacyUrl: optional(import.meta.env.VITE_PRIVACY_URL) ?? '/legal/privacy.html',
} as const;
